import { Injectable } from '@angular/core';

import {
  UserPermissionsService,
  ComplianceCentralService as ComplianceCentralServiceV1,
  TpSafeService
} from '../../../shared/services'; // TODO: Fix / bring this in locally.
import { ReportInformation, ReportDetailsByJurisdiction } from 'src/app/shared/models'; // TODO: Bring into model.
import { UserPermissionsPolicy } from 'src/app/shared/models/user-permissions-policy'; // TODO: Bring into models.
import { ReportStatuses } from 'src/app/shared/constants/report-statuses'; // TOOD: Bring into consants.
import { REPORT_TYPES } from '../../constants';
import { UserRoles } from '@xbs/xbs-enums';
import { AppService } from '../../services/app/app.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

// TODO: This should extend the compliance central service, not DI it.
@Injectable({
  providedIn: 'root'
})
export class ComplianceCentralService {
  activeReportType: string;
  activeReport: any;
  private draftReportDownloadPolicy: UserPermissionsPolicy;
  private navigationPolicy: UserPermissionsPolicy;
  reportDetailsByJurisdiction: ReportDetailsByJurisdiction[];
  reportInformation: ReportInformation[] = [];
  counters: any;

  constructor(private _userPermissionsService: UserPermissionsService,
    private _complianceCentralService: ComplianceCentralServiceV1,
    private appService: AppService,
    private _translateService: TranslateService,
    private _tpSafeService: TpSafeService) {
    this.navigationPolicy = this._userPermissionsService
      .createUserPermissionsPolicy([
        UserRoles.ByName.TPSafeUser.Value,
        UserRoles.ByName.TPDocumentationUser.Value,
        UserRoles.ByName.TPIQUser.Value,
        UserRoles.ByName.TpiqSales.Value,
        UserRoles.ByName.PsgAnalyst.Value,
        UserRoles.ByName.PsgAdmin.Value,
      ]);

    this.draftReportDownloadPolicy = this._userPermissionsService
      .createUserPermissionsPolicy([UserRoles.ByName.TPIQUser.Value, UserRoles.ByName.TpiqSales.Value, UserRoles.ByName.PsgAnalyst.Value, UserRoles.ByName.PsgAdmin.Value]);

    this.appService.onContainerChanged.subscribe(()=>this.initializeReportData(this.activeReportType));
    this.initializeReportData(REPORT_TYPES.localFile);
  }

  initializeReportData(reportType: string): void {
    this.activeReport = null;
    this.reportInformation = [];
    this.reportDetailsByJurisdiction = [];
    this.activeReportType = reportType;

    if (this.activeReportType === REPORT_TYPES.localFile) {
      this.getAllCounters();
    }
    this._complianceCentralService.setReportResourcePaths(this.activeReportType);
    this.getReportInformation();
  }

  /**
   * Downloads the file, derp derp.
   */
  private downloadFile(signedUrl: string): void {
    window.open(signedUrl, '_self');
  }

  /**
   * Wraps the function to grab the container ID.
   */
  getContainerId(): number {
    return this.appService.getCurrentContainer().containerId;
  }

  getActiveReportType() {
    return this.activeReportType;
  }

  /**
   * Gets the report details by jurisdication (usually country???).
   * @param containerId
   * @param domicileId
   */
  async getReportDetailsByJurisdiction(domicileId: number, countryIso: string, reportType: string) {
    this.reportDetailsByJurisdiction = [];
    this.reportDetailsByJurisdiction = await this.appService.getReports(domicileId, reportType, countryIso) as ReportDetailsByJurisdiction[];
    
  }
 
  /**
   * Gets the report and stores it into the `reportInformation` object.
   * @todo Does this also need to sync with the most active container???
   */
  getReportInformation(): void {
    this._complianceCentralService.getReportInformation(this.appService.currentContainer.containerId).subscribe(({ data })=>{
      this.reportInformation = this.formatReportInformation(data);
    });
  }

  formatReportInformation(reportInformation) {
    reportInformation.forEach((report) => {

      report.filingDate = moment.utc(report.filingDate).format('MMMM DD');
      report.prepareByDate = (report.prepareByDate) ? moment.utc(report.prepareByDate).format('MMMM DD') : '';

      report.reportDetailsCollapsed = true;
      report.dropdownCollapsed = false;
    });
    return reportInformation;
  }

  /**
   * Gets a signed URL, derpy derp-twiddle derp.
   */
  getSignedDownloadURL(filePath: string, fileName: string): void {
    this._tpSafeService.getSignedDownloadURL(filePath, fileName,
      this.appService.currentContainer.containerId).subscribe((data) => {
      const signedUrl = data.data.url;
      this.downloadFile(signedUrl);
    });
  }

  /**
   * Translates the string, returning a promise.
   */
  translate(str, params?) {
    return this._translateService.instant(str, params);
  }

  /**
   * @returns {Boolean} True if has draft download policy.
   */
  userHasReportDownloadPermissions(reportStatus?: string): boolean {
    return (reportStatus && reportStatus === ReportStatuses.DRAFT &&
        this._userPermissionsService
          .userHasPermissions(this.draftReportDownloadPolicy)) || true;
  }

  /**
   * Checks navigation permissions.
   */
  userHasNavigationPermissions(): boolean {
    return this._userPermissionsService.userHasPermissions(this.navigationPolicy);
  }

  getAllCounters(): void {
    this._complianceCentralService.getAllCounters(this.getContainerId()).subscribe(({ data }) => {
      const countersObj = data;
      
      const countries = countersObj.countriesCount;
      const total = countersObj.totalReportsCount;
      const pending = countersObj.pendingReportsCount;
      const final = countersObj.finalReportsCount;

      this.counters = {
        countries, total, pending, final
      };
    });
  }
}
